var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticStyle: { height: "150px" } },
    [
      _vm.header_type === "type4"
        ? [
            _c("LogoBar", { attrs: { loading: _vm.loading, data: _vm.data } }),
            _vm._v(" "),
            _vm.$route.name === "Login"
              ? _c("HeaderMenuLogin", {
                  staticClass: "d-none d-md-block",
                  attrs: { loading: _vm.loading, data: _vm.data },
                })
              : _c("HeaderMenu", {
                  staticClass: "d-none d-md-block",
                  attrs: { loading: _vm.loading, data: _vm.data },
                }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }